import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

import { BaseService } from './base.service';

import { UserLoginModel } from '../models/userlogin.model';

@Injectable({
	providedIn: 'root'
})

export class LoginService extends BaseService {
    responseResults: any[] = [];

    constructor(private http: HttpClient) { 
        super();
    }

    public login(user: UserLoginModel){        
        var body = 'userName=' + user.username + '&password=' + encodeURIComponent(user.password) + '&grant_type=password';
        return this.http.post<any>(environment.rootUrl + 'token', body, this.httpFormOptions);
    }

    public logout() {
        return this.http.get<any>(environment.rootUrl + 'signout', this.httpBaseOptions);
    }

    public getProfile() {
        return this.http.get<any>(environment.commonApiUrl + 'userprofile?appGuid=' + environment.appToken, this.httpBaseOptions);
    }
}